export const ARO_CHANNEL_NUSKIN = "1"
export const ARO_CHANNEL_ME_COMMERCE = "7"


//결제 타입
export const VALUE_payment_type_credit_card = "2";
export const VALUE_payment_type_account_transfer = "3";

//양수, 양도
export const VALUE_transfer_status_GET = "1";
export const VALUE_transfer_status_SEND = "2";

//ageloc mileage
export const VALUE_mileage_status_CANCEL = "1";
export const VALUE_mileage_status_APPLY = "2";
export const VALUE_mileage_status_DISABLE = "3";
export const VALUE_mileage_status_CANCEL_DISABLE = "4";

//ageloc grace
export const VALUE_grace_status_CANCEL = "1";
export const VALUE_grace_status_APPLY = "2";
export const VALUE_grace_status_DISABLE = "3";
export const VALUE_grace_status_CANCEL_DISABLE = "4";

//재결제 - 마일리지 및 그레이스 사용 유무
export const VALUE_addpaymenttype_EXIST = ""; //기존방식
export const VALUE_addpaymenttype_GRACE = "G"; //grace
export const VALUE_addpaymenttype_MILEAGE = "M"; //Mileage

//마일리지 결제에 대한 배송비 결제 방식
export const VALUE_fdeliverytype_CREDIT_CARD = "C";
export const VALUE_fdeliverytype_MILEAGE = "M";

//마일리지 결제에 대한 배송비 결제
export const VALUE_AGE_LOC_ME_CUSTOM_PRODUCT_MILEAGE_AMOUNT = "128.81";
export const VALUE_AGE_LOC_ME_CUSTOM_PRODUCT_MILEAGE_AND_DELIVERY_AMOUNT = "130.71";


//커스텀 프로덕트 세트 id
export const ARO_SKINCARE_PRODUCT_ID = "18010000"
//api data 결과 코드
export const ARO_DATA_API_SUCCESS = "0000"
export const ARO_DATA_API_SUCCESS2 = "000"
export const ARO_SKIN_CARE_STOCK_STATUS = "610"
// 장바구니 구분
export const ARO_BASKET_MODE = "ARO"
export const ARO_15_BASKET_MODE = "15ARO"
export const ARO_NTC_BASKET_MODE = "NTC"

//주문 정상
export const MEMBER_HOLDER_TYPE_SUCCESS = "0"
//주문 금지
export const MEMBER_HOLDER_TYPE_SALESHOLDED = "1"
//임시 디스트리뷰터
export const MEMBER_HOLDER_TYPE_DIST_TEMP = "2"



//NTC 상품 코드
export const ARO_NTC_PRODUCT_IDS = ["18113523","18113527"];

//NTC 카드사용동의 약관
export const VALUE_NTC_CARD_USE_TERM = "/terms/cardUse_ntc_01.html";

//에이지락미 카드사용동의 약관
//<br>
export const VALUE_AGG_LOC_ME_CARD_USE_TERM = "/terms/cardUse_agelocme_01.html";
//<li> 철회
export const VALUE_AGG_LOC_ME_CARD_USE_TERM_CANCEL = "/terms/cardUse_agelocme_02.html";
//재결제, 마일리지등
export const VALUE_AGG_LOC_ME_CARD_USE_TERM_SHIPPING = "/terms/cardUse_agelocme_03.html";

//ARO 카드사용동의 약관
//신용카드 자동 승인 약관
export const VALUE_ARO_CARD_USE_TERM_SHORT = "/terms/cardUse_aro_01.html"

//<li> ARO 철회
export const VALUE_ARO_CARD_USE_TERM_CANCEL = "/terms/cardUse_aro_02.html";

//신용카드 자동 승인 약관
export const VALUE_ARO_CARD_USE_TERM = "/terms/orderTerms_card.html";

//정기구매 신청 약관
export const VALUE_ARO_ORDER_TERM = "/terms/orderTerms_normal_v240106d.html";

//15Per 정기구매 신청 약관
export const VALUE_15ARO_ORDER_TERM = "/terms/orderTerms_15per_v240426a.html";

//Ntc 정기 기부 신청 약관
export const VALUE_NTC_ORDER_TERM = "/terms/orderTerms_ntc.html";

//수령 희망일 내용 동의
export const VALUE_WISH_DELIVERY_TERM = "/terms/deliveryTerms.html";

//자동 계좌이체 약관
export const VALUE_BANK_ACCOUNT_REG_TERM = "/terms/bankAccountRegTerms_v200901.html";

//ADP 전환 안내 신청 약관
export const VALUE_ADP_TRANSFORM_TERM = "/terms/adpTransFormTerms.html";



// WEBPACK FOOTER //
// ./src/utils/const.js